import React, { useEffect, useState , useContext } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.png';
import talking from '../assets/Group 24.svg';
import avatars from '../assets/Group 21444.svg';
import chats from '../assets/Group 21459.svg';
import streaming from '../assets/Group 21458.svg';
import generator from '../assets/Group 21449.svg';
import { decodeJWT, UpdateUserLimits,  decodeJWTAndDecryptSub, logPageVisit  } from '../Firebase';
import NavbarBottom from '../components/NavbarBottom';
import '../App.css';

export default function Home() {
    const { t } = useTranslation();

    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const [pageLoader , setPageLoader] = useState(false)



    useEffect(() => {
        

        const initialize = async () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const token = urlParams.get('jwt_token');
            const sessionToken = sessionStorage.getItem('sessionToken');
    
            if (!token) {
                if (!sessionToken) {
                    setAlertMessage(t('portal.home.noPermission'));
                    setAlertType('danger');
                    setIsAlertOpen(true);
                    setIsAuthorized(false);
                } else { 
                    setIsAuthorized(true);
                }
            } else {
                if (!sessionToken) {
                    setPageLoader(true)
                    sessionStorage.setItem('sessionToken', token);
                    await decodeJWTAndDecryptSub(token);
                    setIsAuthorized(true);
                    setPageLoader(false)
                } else {
                    if (sessionToken !== token) {
                        sessionStorage.setItem('sessionToken', token);
                        await refreshUserSessionFromToken(token); // <-- updates AI_UserData
                        setPageLoader(false)
                        setIsAuthorized(true);
                    } else {
                        
                        setIsAuthorized(true);
                    }
                }
            }
                await logPageVisit(window.location.href);

        };
    
        initialize();
    }, []); // Empty dependency array ensures this runs only once
    
async function refreshUserSessionFromToken(token) {
  // 1) Clear any user-scoped caches from the previous identity
  const userScopedKeys = [
    'AI_UserData',
    'AI_MobiLoginResponse',
    'AI_Uploads',
    'AI_Avatars',
    'AI_Streaming',
    'AI_TalkingPhotos',
    'AI_Voices'
  ];
  userScopedKeys.forEach(k => sessionStorage.removeItem(k));

  // 2) Re-bind session to the new identity
  await decodeJWTAndDecryptSub(token); // This will repopulate AI_UserData
}
    const closeAlert = () => {
        setIsAlertOpen(false);
    };

    const handleClick = (path) => {
        if (isAuthorized) {
            window.location.href = `/Portal${path}`;
        } else {
            setAlertMessage(t('portal.home.noPermissionAction'));
            setAlertType('danger');
            setIsAlertOpen(true);
        }
    };

    if(pageLoader){
        return(
            <span className="Spinloader"></span>
        )
    }


    return (
        <>
            <div className="container pt-4" style={{ marginBottom: "15rem" }}>
                <div className="row">
                    <div className="d-flex flex-row  align-items-center gap-2" data-aos="fade-down">
                        <img style={{ borderRadius: '50%', height: '40px' }} src={logo} alt="logo" />
                        <h1 className="notranslate mb-0" translate="no">{t('portal.home.title')}</h1>
                    </div>

                    {isAlertOpen && (
                        <div
                            className={`alert alert-${alertType} alert-dismissible fade show mt-2`}
                            data-aos="fade-right"
                            role="alert"
                        >
                            <h2 className='m-0' >{alertMessage}</h2>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={closeAlert}
                            ></button>
                        </div>
                    )}

                    <div className="grid">
                        <div
                            className={`grid-item grid-item-1`}
                            data-aos="fade-up"
                            onClick={() => handleClick('/talkingphoto')}
                        >
                            <img src={talking} alt="Talking Photo" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">{t('portal.home.talkingPhoto.title')}</h2>
                                    <p className="mb-0">{t('portal.home.talkingPhoto.description')}</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className={`grid-item grid-item-2 `}
                            data-aos="fade-up"
                            onClick={() => handleClick('/avatars')}
                        >
                            <img src={avatars} alt="Avatars" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">{t('portal.home.avatars.title')}</h2>
                                    <p className="mb-0">{t('portal.home.avatars.description')}</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-3"
                            data-aos="fade-up"
                            onClick={() => handleClick('/streaming')}
                        >
                            <img src={streaming} alt="Streaming Avatars" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">{t('portal.home.streamingAvatars.title')}</h2>
                                    <p className="mb-0">{t('portal.home.streamingAvatars.description')}</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-4"
                            data-aos="fade-up"
                            onClick={() => handleClick('/chat?type=chat')}
                        >
                            <img src={chats} alt="AI Chat" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">{t('portal.home.aiChat.title')}</h2>
                                    <p className="mb-0">{t('portal.home.aiChat.description')}</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-5"
                            data-aos="fade-up"
                            onClick={() => handleClick('/chat?type=image')}
                        >
                            <img src={generator} alt="AI Image Generator" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">{t('portal.home.aiImageGenerator.title')}</h2>
                                    <p className="mb-0">{t('portal.home.aiImageGenerator.description')}</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NavbarBottom auth={isAuthorized} />
        </>
    );
}
